"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _queryString = require("query-string");

var _queryString2 = _interopRequireDefault(_queryString);

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

var _jsCookie = require("js-cookie");

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var instance = _axios2.default.create({
  baseURL: "//rd-ewx-login-service-server.qutoutiao.net",
  headers: {
    "Content-Type": "application/json"
  },
  withCredentials: false
});

exports.default = {
  // 跳转登陆
  login: function login(_ref) {
    var _ref$app = _ref.app,
        app = _ref$app === undefined ? "" : _ref$app,
        _ref$url = _ref.url,
        url = _ref$url === undefined ? window.location.href : _ref$url,
        _ref$state = _ref.state,
        state = _ref$state === undefined ? "" : _ref$state,
        _ref$copyright = _ref.copyright,
        copyright = _ref$copyright === undefined ? (0, _stringify2.default)({
      guardian: "", // 维护人
      team: {
        name: "", // 开发组
        link: "" // 组介绍连接
      },
      feedback: "" // 反馈连接
    }) : _ref$copyright;

    window.location.href = instance.defaults.baseURL + "/login?app=" + app + "&redirect_url=" + encodeURIComponent(url) + "&state=" + state + "&copyright=" + copyright;
  },
  getToken: function getToken() {
    var token = _queryString2.default.parse(window.location.search.slice(1)).token || '';
    if (!token) {
      token = _jsCookie2.default.get('ewx-token');
    }
    return token;
  },


  // 获取用户信息
  getUserInfo: function getUserInfo() {
    var _this = this;

    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var tokenInUrl, tokenInCookie, token, hostname, res;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              tokenInUrl = _queryString2.default.parse(window.location.search.slice(1)).token;
              tokenInCookie = _jsCookie2.default.get("ewx-token");
              token = tokenInUrl || tokenInCookie || '';

              if (token) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return", null);

            case 5:
              if (tokenInUrl) {
                hostname = /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n?]+)/gim.exec(window.location)[1];

                _jsCookie2.default.set("ewx-token", token, {
                  expires: 7,
                  domain: hostname === "localhost" || /\b((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.|$)){4}\b/gim.test(hostname) ? hostname : "." + hostname
                });
              }

              _context.next = 8;
              return instance.post("/api/userinfo", {
                token: token
              });

            case 8:
              res = _context.sent;

              if (!(res.status === 200 && !res.data.code)) {
                _context.next = 13;
                break;
              }

              return _context.abrupt("return", res.data.response);

            case 13:
              return _context.abrupt("return", null);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  // 登出
  logout: function logout() {
    var _this2 = this;

    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
      var tokenInUrl, tokenInCookie, token, res;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              tokenInUrl = _queryString2.default.parse(window.location.search.slice(1)).token;
              tokenInCookie = _jsCookie2.default.get("ewx-token");
              token = tokenInUrl || tokenInCookie || '';

              if (token) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt("return", null);

            case 5:
              _context2.next = 7;
              return instance.post("/api/logout", {
                token: token
              });

            case 7:
              res = _context2.sent;

              if (res.status === 200) {
                if (!res.data.code) {
                  _jsCookie2.default.remove("ewx-token");
                }
              }
              return _context2.abrupt("return", true);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
};
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/@qtt/ewx-login-sdk/lib/noperm.js
// module id = 246
// module chunks = 15